// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3IuZ-","footer":"ModalFilter_footer__1wjT_"};